import aboutus from './aboutus/routes';
import contactus from './contactus/routes';
import impressum from './impressum/routes';
import accessibilitystatement from './accessibility/routes';

export default [aboutus, contactus, impressum, accessibilitystatement];
